var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createMuiTheme } from "@material-ui/core/styles";
import { affinityColors } from "./styleData";
import { baseThemeOptions, createOverrides } from "../_base";
// See https://material-ui.com/customization/default-theme/ for avaliable options
// TODO: Fix the typescript warnings. Theme def errors
var baseAffinityTheme = createMuiTheme(__assign(__assign({}, baseThemeOptions), { 
    // add Affinity specific theme options here
    palette: {
        common: {
            black: affinityColors.commonBlack.value,
            white: affinityColors.commonWhite.value
        },
        primary: {
            light: affinityColors.primaryLight.value,
            main: affinityColors.primary.value,
            dark: affinityColors.primaryDark.value,
            contrastText: "#fff"
        },
        secondary: {
            light: affinityColors.secondaryLight.value,
            main: affinityColors.secondary.value,
            dark: affinityColors.secondaryDark.value,
            contrastText: "#fff"
        },
        success: {
            light: affinityColors.successLight.value,
            main: affinityColors.success.value,
            dark: affinityColors.successDark.value,
            contrastText: "#fff"
        },
        error: {
            light: affinityColors.errorLight.value,
            main: affinityColors.error.value,
            dark: affinityColors.errorDark.value,
            contrastText: "#fff"
        },
        warning: {
            light: affinityColors.warningLight.value,
            main: affinityColors.warning.value,
            dark: affinityColors.warningDark.value,
            contrastText: "#fff"
        },
        info: {
            light: affinityColors.infoLight.value,
            main: affinityColors.info.value,
            dark: affinityColors.infoDark.value,
            contrastText: "#fff"
        },
        grey: __assign({}, [50, 100, 200, 300, 400, 500, 600, 700, 800, 900].reduce(function (acc, curr) {
            var _a;
            return (__assign(__assign({}, acc), (_a = {}, _a[curr] = affinityColors["grey" + curr].value, _a)));
        }, 50)),
        text: {
            primary: affinityColors.textPrimary.value,
            secondary: affinityColors.textSecondary.value,
            disabled: affinityColors.textDisabled.value
        },
        background: {
            default: affinityColors.neutralGhost.value
        },
        divider: affinityColors.divider.value,
        action: {
            active: affinityColors.actionActive.value,
            hover: affinityColors.actionHover.value,
            selected: affinityColors.actionSelected.value,
            disabled: affinityColors.actionDisabled.value,
            disabledBackground: affinityColors.actionDisabledBackground.value
        }
    } }));
// JSS styling overrides
var overrides = __assign(__assign({}, createOverrides(baseAffinityTheme)), { 
    // add Affinity specific overrides here
    MuiCardHeader: {
    // title: {
    //   fontSize: "1rem"
    // },
    // TODO: Decide what the rule is about header color.
    // Applying this mlooks right in some places but wrong in others.
    // Think Sales price book tables vs data cards or CPQ selection areas
    // root: {
    //   backgroundColor: affinityColors.neutralStorm.value,
    //   color: "#fff"
    // }
    } });
var affinityTheme = createMuiTheme(__assign(__assign({}, baseAffinityTheme), { overrides: overrides }));
export { affinityTheme, affinityColors };
//# sourceMappingURL=index.js.map